import React, {useEffect, useState} from "react";
import "./AdminModern.scss";
import Swal from "sweetalert2";
import GoingBack from "../../components/GoingBack/GoingBack";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import IsAdmin from "../../components/Admin/IsAdmin";
import uploadImage from "../../services/UploadImage";
import formValid from "../../services/FormProductValid";
import {Loader} from "../../utils/Loader";

function AdminAddProduct() {
    const [nomProduit, setNomProduit] = useState("");
    const [categoryProduit, setCategoryProduit] = useState("");
    const [sousCategoryProduit, setSousCategoryProduit] = useState("");
    const [lienImageProduit, setLienImageProduit] = useState([]);
    const [prixProduit, setPrixProduit] = useState();
    const [descriptionProduit, setDescriptionProduit] = useState("");
    const [nomsPierres, setNomsPierres] = useState("");
    const [couleursPierres, setCouleursPierres] = useState("");
    const [formulaireCorrect, setFormulaireCorrect] = useState(false);
    const [readyToUploadImage, setReadyToUploadImage] = useState(false);
    const [idPrixStripe, setIdPrixStripe] = useState("");
    const [image, setImage] = useState([]);
    const [fileName, setFileName] = useState('Choisissez un ou plusieurs fichier(s)');
    let file = null;
    const [isAdmin, setIsAdmin] = useState(null);
    const navigate = useNavigate();
    const [productOnSale, setProductOnSale] = useState(false);
    const [isDataLoading, setDataLoading] = useState(false);

    useEffect(() => {
        if (isAdmin === null) {
            return;
        }
        !isAdmin && navigate("/");
    }, [isAdmin]);

    useEffect(() => {
        if (!lienImageProduit || lienImageProduit.length === 0) {
            return;
        }
        const addProductStripe = async () => {
            const product = {
                name: nomProduit,
                description: descriptionProduit,
                images: lienImageProduit,
                price: prixProduit
            }
            setDataLoading(true)
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}products/create-stripe-product`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get("auth_token")}`,
                    },
                    body: JSON.stringify({product: product}),
                });
                const idPrixStripe = await response.json();
                setIdPrixStripe(idPrixStripe);
            } catch (e) {
                setDataLoading(false)
            }
        }
        addProductStripe();
    }, [lienImageProduit]);

    useEffect(() => {
        if (!idPrixStripe) {
            return;
        }
        const addProduct = () => {
            const timestamp = new Date().getTime();
            const uniqueId = `${timestamp}`;
            const produit = {
                id: uniqueId,
                name: nomProduit,
                category: categoryProduit,
                secondary_category: sousCategoryProduit,
                covers: lienImageProduit,
                price: prixProduit,
                description: descriptionProduit,
                idPrixStripe: idPrixStripe.idPrixStripe,
                pierres: nomsPierres && (categoryProduit === "Bijoux") ? nomsPierres : undefined,
                color: couleursPierres && (categoryProduit === "Bijoux") ? couleursPierres : undefined,
                onSale: productOnSale
            }
            const addProductToDatabase = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API_URL}products/add`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${Cookies.get("auth_token")}`,
                        },
                        body: JSON.stringify(produit)
                    });
                    if (response.ok) {
                        Swal.fire({
                            text: "Produit ajouté avec succès",
                            icon: "success"
                        })
                    }
                } catch (e) {
                    console.log(e);
                    setDataLoading(false)
                } finally {
                    setDataLoading(false)
                }
            }
            addProductToDatabase();
        }
        addProduct();
    }, [idPrixStripe]);

    const handleImageUpload = event => {
        const files = Array.from(event.target.files);
        setImage(files);
        const fileNames = files.map(file => file.name).join('\n');
        setFileName(fileNames);
    };

    useEffect(() => {
        if (!lienImageProduit) {
            return;
        }

    }, [lienImageProduit]);

    return (
        <div className="admin-modern-container">
            <IsAdmin setAdmin={setIsAdmin}/>
            <GoingBack/>
            {!isAdmin ? null : (
                <>
                    <div className="admin-header">
                        <h2>Formulaire d'ajout d'un produit</h2>
                        <p>Ajoutez un nouveau produit sur la boutique</p>
                    </div>
                    <div className="admin-card" style={{ maxWidth: "800px", margin: "0 auto" }}>
                        <div className="admin-grid-2">
                            <div className="admin-form-group">
                                <label>Nom du produit</label>
                                <input className="admin-input" type="text"
                                       onChange={(e) => setNomProduit(e.target.value)}
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>Prix Produit (€)</label>
                                <input className="admin-input" type="number"
                                       onChange={(e) => setPrixProduit(e.target.value)}/>
                            </div>
                            
                            <div className="admin-form-group" style={{ gridColumn: "1 / -1" }}>
                                <label>Description du produit</label>
                                <textarea className="admin-input" style={{ resize: "vertical", minHeight: "100px" }}
                                       onChange={(e) => setDescriptionProduit(e.target.value)}/>
                            </div>

                            <div className="admin-form-group">
                                <label>Catégorie du produit</label>
                                <select className="admin-select" value={categoryProduit} onChange={(e) => setCategoryProduit(e.target.value)}>
                                    <option value="">Choisir une catégorie</option>
                                    <option value="Bijoux">Bijoux et accessoires</option>
                                    <option value="Zen">Ambiance zen</option>
                                    <option value="Bien etre">Bien être</option>
                                </select>
                            </div>

                            {categoryProduit && (
                                <div className="admin-form-group">
                                    <label>Sous catégorie du produit</label>
                                    <select className="admin-select" value={sousCategoryProduit}
                                            onChange={(e) => setSousCategoryProduit(e.target.value)}>
                                        <option value="">Choisir une sous-catégorie</option>
                                        {(categoryProduit === "Bijoux") && (
                                            <>
                                                <option value="Bracelet">Bracelet</option>
                                                <option value="Boucle Oreille">Boucles d'oreilles</option>
                                                <option value="Accessoire">Accessoire</option>
                                            </>
                                        )}
                                        {(categoryProduit === "Zen") && (
                                            <>
                                                <option value="Lampe sel">Lampe de sel</option>
                                                <option value="Fontaine interieur">Fontaine d'intérieur</option>
                                                <option value="Diffuseur">Diffuseur d'ambiance</option>
                                                <option value="bruleur_parfum">Brûleur parfum</option>
                                                <option value="Statue">Statue</option>
                                            </>
                                        )}
                                        {(categoryProduit === "Bien etre") && (
                                            <>
                                                <option value="Purifier">Purifier - Assainir</option>
                                                <option value="Plateau recharge">Plateau de recharge</option>
                                                <option value="Orgonite">Orgonite</option>
                                            </>
                                        )}
                                    </select>
                                </div>
                            )}

                            {categoryProduit === "Bijoux" &&
                                <>
                                    <div className="admin-form-group">
                                        <label>Nom des pierres (ex: Diamant,Rubis)</label>
                                        <input className="admin-input" type="text"
                                               onChange={(e) => setNomsPierres(e.target.value)}/>
                                    </div>
                                    <div className="admin-form-group">
                                        <label>Couleurs (ex: Rouge,Gris)</label>
                                        <input className="admin-input" type="text"
                                               onChange={(e) => setCouleursPierres(e.target.value)}/>
                                    </div>
                                </>
                            }

                            <div className="admin-form-group" style={{ gridColumn: "1 / -1" }}>
                                <div className="admin-checkbox-group">
                                    <input type="checkbox" checked={productOnSale} id="productOnSale"
                                           onChange={(e) => setProductOnSale(e.target.checked)}/>
                                    <label htmlFor="productOnSale">Rendre ce produit visible et disponible à l'achat</label>
                                </div>
                            </div>

                            <div className="admin-form-group" style={{ gridColumn: "1 / -1" }}>
                                <label>Ajouter des photos</label>
                                <input type="file" id="file" style={{display: 'none'}} multiple onChange={handleImageUpload}/>
                                <label htmlFor="file" className="admin-file-label">
                                    <svg style={{width:"2rem", height:"2rem", margin:"0 auto 0.5rem auto", display:"block", color:"var(--admin-text-muted)"}} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                                    {fileName === 'Choisissez un ou plusieurs fichier(s)' ? 'Cliquez ici pour ajouter des photos' : fileName}
                                </label>
                            </div>

                            <div style={{ gridColumn: "1 / -1", marginTop: "1rem" }}>
                                {isDataLoading ? (
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                                        <Loader/>
                                    </div>
                                ) : (
                                    <button className="admin-btn admin-btn-primary"
                                            onClick={() => uploadImage(formValid(nomProduit, categoryProduit, descriptionProduit, sousCategoryProduit, prixProduit, image), setLienImageProduit, image)}>
                                        <svg style={{width:"1.2rem", height:"1.2rem"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>
                                        Ajouter le produit
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default AdminAddProduct;
